export default __webpack_public_path__ + "static/media/logoHeader1.5e91a369.png";